<template>
  <div class="page">
    <top-header></top-header>
    <b-container fluid style="margin-top:5% !important">
      <b-row class="mt-3 mb-2">
        <b-col class="col-md-6 col-sm-6 col-xs-6">
          <h3>
            Download Reports: {{ $route.params.reporttype.charAt(0).toUpperCase() + $route.params.reporttype.slice(1) }}
          </h3>
        </b-col>
        <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
          <b-button variant="dark" pill class="mr-2" @click="showAddReportModal()">Generate Report</b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <b-row>
        <b-col class="col-md-12 col-sm-12 col-xs-12">
          <div class="container-box">
            <b-row class="mt-4 px-3">
              <b-col lg="6">
                <span class="mr-2">Show</span>
                <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
                </b-form-select>
                <span class="ml-2">entries</span>
              </b-col>
              <b-col lg="4" offset-md="2">
                <b-form-group
                  label="Filter"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
                    </b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="px-3 pt-3">
              <b-col lg="12">
                <b-table
                  show-empty
                  sticky-header
                  small
                  striped
                  outlined
                  id="my-table"
                  stacked="md"
                  :items="records"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :filterIncludedFields="filterOn"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(status)="row">
                    <b-badge pill variant="danger" v-if="row.value == 0">PROCESSING</b-badge>
                    <b-badge pill variant="success" v-else>COMPLETE</b-badge>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <b-button
                      pill
                      variant="primary"
                      class="mr-1"
                      :href="$session.get('apiurl') + '/exports/' + row.item.link"
                      @click="download(row.item.id)"
                      target="_blank"
                      download
                      ><b-icon icon="arrow-down" scale="1.5"></b-icon>XLS</b-button
                    >
                    <b-button
                      pill
                      variant="primary"
                      class="mr-1"
                      :href="$session.get('apiurl') + '/exports/' + row.item.link.replace('.csv', '.pdf')"
                      @click="download(row.item.id)"
                      target="_blank"
                      download
                      ><b-icon icon="arrow-down" scale="1.5"></b-icon>PDF</b-button
                    >
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row class="px-3">
              <b-col lg="6">
                <span class="mr-2"
                  >Showing {{ currentPage }} to {{ perPage > records.length ? records.length : perPage }} of
                  {{ records.length }} entries</span
                >
              </b-col>
              <b-col lg="3" offset-md="3">
                <b-pagination
                  v-model="currentPage"
                  pills
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="right"
                  size="sm"
                  prev-text="Prev"
                  next-text="Next"
                  first-number
                  last-number
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-modal id="my-model" :title="modelTitle" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group label="State" label-cols="3" label-size="sm" label-align-sm="right">
            <b-form-select
              v-model="selectedItem.state"
              @change="
                selectedItem.district = 0;
                selectedItem.ulb = 0;
              "
            >
              <b-form-select-option value="0">--- Select State ---</b-form-select-option>
              <b-form-select-option v-for="item in $root.state_options" v-bind:key="item.id" :value="item.value">{{
                item.text
              }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
          <!--<b-form-group label="District" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.district" @change="selectedItem.ulb=0">
							<b-form-select-option value="0">--- Select District ---</b-form-select-option>
							<b-form-select-option v-for="item in filterZone(zones)" v-bind:key="item.id" :value="item.id">{{item.title}}</b-form-select-option>
						</b-form-select>
					</b-form-group>-->
          <b-form-group label="ULB" label-cols="3" label-size="sm" label-align-sm="right">
            <b-form-select v-model="selectedItem.ulb" :disabled="selectedItem.id > 0">
              <b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
              <b-form-select-option v-for="item in filterULB(zones)" v-bind:key="item.id" :value="item.id">{{
                item.title
              }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Start Date" label-cols="3" label-size="sm" label-align-sm="right">
            <b-form-datepicker
              v-model="selectedItem.start_date"
              show-decade-nav="false"
              :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
              :hide-header="true"
            ></b-form-datepicker>
          </b-form-group>
          <b-form-group label="End Date" label-cols="3" label-size="sm" label-align-sm="right">
            <b-form-datepicker
              v-model="selectedItem.end_date"
              show-decade-nav="false"
              :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
              :hide-header="true"
            ></b-form-datepicker>
          </b-form-group>
        </form>
        <template v-slot:modal-footer="{ ok, close }">
          <b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
          <b-button size="sm" variant="success" @click="ok()"
            ><span
              class="spinner-border spinner-border-sm"
              v-if="loading_status"
              role="status"
              aria-hidden="true"
            ></span
            >&nbsp;{{ selectedItem.id > 0 ? "Update" : "Submit" }}</b-button
          >
        </template>
      </b-modal>
    </b-container>
    <transition name="fade">
      <b-row
        v-if="loading"
        class="loading"
        style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);"
        align-v="center"
        align-h="center"
      >
        <b-spinner label="Busy" variant="light"></b-spinner>
      </b-row>
    </transition>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
  name: "Devices",
  components: {
    "top-header": Header,
  },
  mounted() {
    var self = this;
    Object.assign(self.selectedItem, self.emptyItem);
    this.initload();
  },
  data() {
    var self = this;
    return {
      loading: true,
      modelTitle: "",
      loading_status: false,
      password: "",
      recordsUrl: self.$session.get("apiurl") + "kmrlapi/reports-records",
      generateUrl: self.$session.get("apiurl") + "kmrlapi/reports-generate",
      downloadUrl: self.$session.get("apiurl") + "kmrlapi/reports-download",
      records: [],
      zones: [],
      fields: [
        { key: "id", label: "ID" },
        { key: "user_id", label: "User" },
        { key: "type", label: "Report Type" },
        { key: "report_id", label: "Report Field" },
        {
          key: "report_date",
          label: "Report Date",
          formatter: (value, key, item) => {
            var date = item.report_date.split(" - ");
            if (date.length > 1) {
              return this.$moment(date[0]).format("DD-MM-YYYY") + " - " + this.$moment(date[1]).format("DD-MM-YYYY");
            } else {
              if (item.report_date == "") {
                return "00-00-0000";
              }
              return this.$moment(item.report_date).format("DD-MM-YYYY");
            }
          },
        },
        { key: "records", label: "Total Rows" },
        { key: "downloads", label: "Downloads" },
        { key: "status", label: "Status" },
        {
          key: "insert_time",
          label: "Added Time",
          formatter: (value, key, item) => {
            if (item.insert_time == "") {
              return "00-00-0000 00:00:00";
            }
            return this.$moment(item.insert_time).format("DD-MM-YYYY HH:mm:ss");
          },
        },
        { key: "actions", label: "Download", extra: 1, class: "text-right" },
      ],
      totalRows: 1,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      selectedItem: {
        state: this.$session.get("user_info").permissions.state_perm,
        district: "",
        ulb: "",
      },
      emptyItem: {
        id: 0,
        type: "",
        state: "",
        district: "",
        date: "",
      },
    };
  },
  methods: {
    filterZone: function(items) {
      var self = this;
      console.log("xxxx" + self.selectedItem.state);
      return items.filter(function(item) {
        if (item.parent == 0 && item.state == self.selectedItem.state) {
          return true;
        }
      });
    },
    filterULB: function(items) {
      var self = this;
      return items.filter(function(item) {
        return item.state == self.selectedItem.state;
      });
    },
    showAddReportModal() {
      this.selectedItem = Object.assign({}, this.emptyItem);
      this.selectedItem.state = this.$session.get("user_info").permissions.state_perm;
      this.selectedItem.ulb = "";
      this.selectedItem.type = "ULB";
      this.modelTitle = "Generate Report";
      this.$root.$emit("bv::show::modal", "my-model");
    },
    showDeleteModal(item) {
      var self = this;
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete complaint.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            self.axios
              .post(self.deleteUrl, {
                accesskey: self.$session.get("access_key"),
                deleteid: item.id,
              })
              .then(function(response) {
                if (response.data.error == 0 || response.data.error == "0") {
                  self.$bvToast.toast(response.data.message, {
                    title: "Delete",
                    toaster: "b-toaster-bottom-right",
                    autoHideDelay: 5000,
                    variant: "warning",
                    solid: true,
                    appendToast: true,
                  });
                  self.initload();
                } else if (response.data.error == "2" || response.data.error == 2) {
                  self.$root.forceLogout(response.data.message);
                } else {
                  self.$root.showMessage("Server Error", "Reload again", "ok", function() {
                    self.initload();
                  });
                }
              })
              .catch(function(error) {
                alert(error);
              });
          } else {
            //alert('no '+item.id);
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },
    modalSubmit(bvModalEvt) {
      var self = this;
      if (self.loading_status) {
        return;
      }
      self.loading_status = true;
      bvModalEvt.preventDefault();
      var submitUrl = "";

      submitUrl = self.generateUrl;
      self.selectedItem.ulb=1;

      self.axios
        .post(submitUrl, {
          accesskey: self.$session.get("access_key"),
          data: self.selectedItem,
          type: self.$route.params.reporttype,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.$bvModal.hide("my-model");
            self.loading_status = false;
            self.$bvToast.toast(response.data.message, {
              title: "Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
            self.initload();
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },

    resetSelectedItem() {
      var self = this;
      self.selectedItem = Object.assign({}, self.emptyItem);
    },
    initload() {
      var self = this;

      self.axios
        .post(self.recordsUrl, {
          accesskey: self.$session.get("access_key"),
          type: self.$route.params.reporttype,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            //var filteredarr = self.filtercategory(response.data.result);

            self.records = response.data.result.records;
            self.loading = false;
            self.totalRows = self.records.length;
            self.zones = response.data.result.zones;

            /*const zoneOptions = arr.reduce((acc, current) => {
						const x = acc.find(item => item.value === current.value);
						if (!x) {
							return acc.concat([current]);
						} else {
							return acc;
						}
					}, []);*/
            /*self.zoneOptions = [];
					self.records.forEach(function(item){
						if(item.parent == 0){
							self.zoneOptions.push({value:item.id, text:item.title, state:item.state});
						}
						
                    });*/

            /*self.$bvToast.toast(response.data.message, {
						title: 'Record Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});*/
          }
          setTimeout(self.initload, 1000 * 300);
        })
        .catch(function(error) {
          alert(error);
        });
      //alert('login '+self.email+" "+self.password);
    },
    /*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    download(row_id) {
      var self = this;

      self.axios
        .post(self.downloadUrl, {
          accesskey: self.$session.get("access_key"),
          id: row_id,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.$bvToast.toast(response.data.message, {
              title: "Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
  },
};
</script>
<style>
html {
  min-height: 100%;
}
body {
  background-color: "#FFF" !important;
  background-image: none !important;
}
.table {
  font-size: small;
}
.table .btn {
  font-size: 12px;
}
.table td,
.table th {
  vertical-align: middle;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
